import React, { useState } from 'react';

import type { TransitionDirection } from '.';

type PageTransitionContextType =
  | {
      direction: TransitionDirection;
      setDirection: React.Dispatch<React.SetStateAction<TransitionDirection>>;
    }
  | undefined;

const PageTransitionContext = React.createContext<PageTransitionContextType>(undefined);

type PageTransitionProviderProps = {
  children: React.ReactNode;
};

export const PageTransitionProvider: React.FC<PageTransitionProviderProps> = ({ children }): JSX.Element => {
  const [direction, setDirection] = useState<TransitionDirection>('off');

  return (
    <PageTransitionContext.Provider value={{ direction, setDirection }}>{children}</PageTransitionContext.Provider>
  );
};

export const usePageTransition = () => {
  const context = React.useContext(PageTransitionContext);

  if (context === undefined) throw new Error('usePageTransition must be used inside a PageTransitionProvider.');

  return context;
};
